import { Navigate } from "react-router-dom";
import { useConfig } from "@/context/ConfigContext";
import { useT } from "@/i18n";
import { EmptyState } from "@/components/EmptyState";
import { Compass } from "lucide-react";

// Módulos de la capa de Desarrollo y el flag que los controla.
const MODULES = [
    ["personalMastery", "dev.module.personalMastery"],
    ["lifeBalance", "dev.module.lifeBalance"],
    ["goals", "dev.module.goals"],
    ["values", "dev.module.values"],
    ["habits", "dev.module.habits"],
    ["mindset", "dev.module.mindset"],
    ["socialSkills", "dev.module.socialSkills"],
    ["socialChallenges", "dev.module.socialChallenges"],
    ["conversationAI", "dev.module.conversationAI"],
    ["leadershipAcademy", "dev.module.leadershipAcademy"],
    ["teamDevelopment", "dev.module.teamDevelopment"],
    ["teamGrowthSimulator", "dev.module.teamGrowthSimulator"],
];

export default function Desarrollo() {
    const { features, ready, anyDevEnabled } = useConfig();
    const { t } = useT();

    if (!ready) return null;
    // Preparado pero desactivado: si no hay ningún módulo activo, no se expone.
    if (!anyDevEnabled) return <Navigate to="/app" replace />;

    const enabled = MODULES.filter(([flag]) => features[flag]);

    return (
        <div className="space-y-8" data-testid="desarrollo-page">
            <div>
                <div className="flex items-center gap-2 text-nm-accent">
                    <Compass className="h-4 w-4" />
                    <span className="text-xs font-medium uppercase tracking-wider">{t("dev.nav")}</span>
                </div>
                <h1 className="mt-2 text-3xl font-bold tracking-tight text-nm-ink">{t("dev.hub.title")}</h1>
                <p className="mt-1 max-w-prose text-nm-muted">{t("dev.hub.subtitle")}</p>
            </div>

            {enabled.length === 0 ? (
                <EmptyState testId="desarrollo-empty" title={t("dev.hub.empty.title")} description={t("dev.hub.empty.body")} />
            ) : (
                <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                    {enabled.map(([flag, labelKey]) => (
                        <div key={flag} className="rounded-2xl border border-nm-line bg-nm-surface p-6" data-testid={`dev-module-${flag}`}>
                            <h2 className="text-lg font-semibold text-nm-ink">{t(labelKey)}</h2>
                            <span className="mt-3 inline-flex items-center rounded-full bg-nm-accent-soft px-2.5 py-0.5 text-xs font-medium text-nm-accent">
                                {t("dev.hub.soon")}
                            </span>
                        </div>
                    ))}
                </div>
            )}

            <p className="border-t border-nm-line pt-6 text-sm text-nm-muted">{t("dev.progression")}</p>
        </div>
    );
}
